import { getRootDomain } from './domainName'

const document = typeof window !== 'undefined' ? window.document : {}

export const isCookiesEnabled = (() => {
  try {
    document.cookie = 'cookietest=1'
    const cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1
    document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    return cookiesEnabled
  } catch (e) {
    return false
  }
})()

export const readCookie = (name) => {
  try {
    let cookieValue
    if (isCookiesEnabled) {
      cookieValue = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`)
    }
    return cookieValue ? cookieValue[2] : null
  } catch (e) {
    return null
  }
}

export const createCookie = (name, value) => {
  const cookieDomain = `.${getRootDomain(document.location.href)}`
  const nextMonth = new Date(Date.now() + 1 * 24 * 60 * 60 * 1000).toGMTString()
  document.cookie = `${name}=${value}; path=/; domain=${cookieDomain}; expires=${nextMonth}`
}

export const deleteCookie = (name) => {
  const cookieDomain = `.${getRootDomain(document.location.href)}`
  document.cookie = `${name}=; path=/; domain=${cookieDomain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}
